import { render, staticRenderFns } from "./stakingList.vue?vue&type=template&id=304f399a&scoped=true&"
import script from "./stakingList.vue?vue&type=script&lang=js&"
export * from "./stakingList.vue?vue&type=script&lang=js&"
import style0 from "./stakingList.vue?vue&type=style&index=0&id=304f399a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304f399a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('304f399a')) {
      api.createRecord('304f399a', component.options)
    } else {
      api.reload('304f399a', component.options)
    }
    module.hot.accept("./stakingList.vue?vue&type=template&id=304f399a&scoped=true&", function () {
      api.rerender('304f399a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/mining/staking/stakingList.vue"
export default component.exports